import { Route, Routes } from 'react-router-dom';

import { Content } from '@/features/calendar/layouts/content/content';
import { ClassicServicesLayout } from '@/features/services/layouts/ClassicServicesLayout';
import ServiceTable from '@/features/services/layouts/ServiceTable';

// The same screens as `ServicesRoutes`, inside the layout with their own menu.
export const ClassicServicesRoutes = () => {
  return (
    <Routes>
      <Route element={<ClassicServicesLayout />}>
        <Route path="" element={<Content />} />
        <Route path="catalogo" element={<ServiceTable />} />
      </Route>
    </Routes>
  );
};
